import ContractRetentionTemplates from './ContractRetentionTemplates';
import React, {useState, useEffect} from 'react';
import {useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import axios from "axios";

const ContractShowComponent = (props) => {

  const {t} = props;
  const {entity, id} = useParams();
  const [savingRetentions, setSavingRetentions] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  useEffect(() => {
    const contractId =
      props.contractId ||
      props.id ||
      window.App.urlVars().contractId ||
      window.App.urlVars().contract ||
      (entity === 'contract' ? id : null);
    if (contractId) {
      setLoading(true);
      apiCall('get', '/api/v2/contract/' + contractId)
        .then(response => {
          setFormData(response.data.data);
          if (props.onLoaded) {
            props.onLoaded(response.data.data || {});
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [props.contractId, props.id, entity, id]);

  return (
    <div className={"contract-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <div className={"p-grid"}>
        <div className={"p-col-12 p-lg-8"}>
          <div className="p-field p-fluid">
            <label htmlFor="name">{t('columnName')}</label>
            <span className="p-d-block fake-input">
                    {formData.name}
                  </span>
          </div>
        </div>
        <div className={"p-col-12 p-lg-4"}>
          <div className="p-field p-fluid">
            <label htmlFor="project_type">{t('columnProjectType')}</label>
            <span className="p-d-block fake-input">
                    {formData?.project_type?.name}
                  </span>
          </div>
        </div>
        <div className={"p-col-12 p-lg-4"} id="partner">
          <div className="p-field p-fluid">
            <label htmlFor="partner">{t('columnPartner')}</label>
            <span className={"p-d-block fake-input"}>
                    {formData?.partner?.name}
                  </span>
          </div>
        </div>
        <div className={"p-col-12 p-lg-4"}>
          <div className="p-field p-fluid">
            <label htmlFor="company">{t('columnCompany')}</label>
            <span className={"p-d-block fake-input"}>
                    {formData.company?.name}
                  </span>
          </div>
        </div>
        <div className={"p-col-12 p-lg-4"}>
          <div className="p-field p-fluid">
            <label htmlFor="company">{t('columnContractAmount')}</label>
            <span className={"p-d-block fake-input"}>
                    {formData.net_amount}
                  </span>
          </div>
        </div>
        <div className={"p-col-12 p-lg-4"}>
          <div className="p-field p-fluid">
            <label htmlFor="vat_rate">{t('fieldDefaultVatRate')}</label>
            <span className={"p-d-block fake-input"}>
                    {formData?.vat_rate?.label || '-'}
                  </span>
          </div>
        </div>
        <div className={"p-col-12 p-lg-12"}>
          <div className="p-field p-fluid">
            <label htmlFor="description">{t('columnDescription')}</label>
            <span className={"p-d-block fake-input"}>
                    {formData.description}
                  </span>
          </div>
        </div>
      </div>
    {formData.type === 'SUBCONTRACTOR' && !loading && formData.id &&
          <ContractRetentionTemplates key={formData.id} value={formData.retention_templates || []} t={t}
            currency={formData.currency} saving={savingRetentions}
            readOnly={!(localStorage.getItem('roles') || '').includes('role_project_contract_write')}
            onChange={async templates => {
              setSavingRetentions(true);
              try {
                const response = await apiCall('patch', '/api/v2/contract/' + formData.id, {retention_templates: templates});
                setFormData(response.data.data);
                window.App.toastShow('success', 'Sikeres mentés!');
                window.App.setState({rerenderContractList: Math.random()});
                if (props.onLoaded) props.onLoaded(response.data.data);
                return true;
              } catch (error) {
                window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                return false;
              } finally {
                setSavingRetentions(false);
              }
            }}/>
      }
      </div>
  )
}
export default withTranslation('common')(ContractShowComponent);
